<template>
  <v-app v-if="isMounted">
    <router-view></router-view>
  </v-app>
</template>

<script>
import firebase from "@/firebase";
export default {
  data() {
    return {
      isMounted: false
    };
  },
  methods: {
    async typesSet() {
      const snapshot = await firebase.db
        .collection("general")
        .doc("practices")
        .get();
      this.$store.dispatch("updateTypes", snapshot.data().types);
      this.isMounted = true;
    }
  },
  mounted() {
    this.typesSet();
  }
};
</script>
<style lang="scss">
.center-content {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
.big-title {
  font-size: 7rem;
}
</style>